/**
 * Created by Ning Jiang on 11/22/2016.
 */

/*
⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠟⠁⣠⣤⣤⣤⣤⣤⣀⣀⠉⠻⣿⣿⣿⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⣿⣿⠏⠄⣾⣬⣽⣿⣿⣿⣿⡿⢿⣿⣆⠈⢻⣿⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⣿⡿⢀⣞⡉⢩⣙⣿⡿⠉⠄⣠⣤⠤⠉⠄⠄⢿⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⣿⠁⣼⣿⣿⣯⣿⣿⠁⢰⣾⣦⡤⠄⢀⣶⡀⠸⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⡏⢀⣿⣿⣿⣿⣿⠟⠁⠄⠈⢿⣿⣿⣿⣿⡇⠄⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⠇⢸⣿⣿⡟⠛⠃⡠⠄⠄⠄⠈⣿⣿⣿⣿⡇⠄⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⠄⣿⣿⣿⣶⣾⣿⣿⣿⣤⣤⣄⣘⣿⣿⠁⡀⠄⢻⣿⣿⣿
⣿⣿⣿⣿⣿⣿⡇⢰⣿⣿⣿⣿⣿⣏⣉⣽⣿⣿⣿⣿⣿⣿⣿⣿⠄⢸⣿⣿⣿
⣿⣿⣿⣿⣿⣿⠄⣼⣿⣁⣸⣿⣿⣿⣿⣿⡿⠟⠉⠙⠋⠹⠟⠁⠄⢸⣿⣿⣿
⣿⣿⣿⣿⣿⡏⢀⣿⣿⣿⣿⠋⢠⣤⣤⣤⣤⠈⢿⣿⣷⣦⣄⠄⠄⢸⣿⣿⣿
⣿⠋⣀⣤⣄⣠⣼⣿⣿⣿⣿⡀⢹⣿⣿⣿⣿⠄⢸⣿⣿⣿⣿⣿⠄⢸⣿⣿⣿
⣧⠄⢿⣿⣿⣿⣿⣿⣿⣿⡿⠃⢸⠿⠛⠉⣁⣠⣿⣿⣿⣿⣿⣿⠄⣼⣿⣿⣿
⣿⣷⣄⣉⠉⠉⢉⣉⣉⣁⣤⣾⡏⠄⣾⣿⣿⣿⣿⣿⣿⣿⣿⡟⠄⣿⣿⣿⣿
⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⣤⣈⠙⠛⠛⠟⠛⠛⢉⣁⣤⣾⣿⣿⣿⣿ SNUS
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {PossessedGameAssets} from "./PossessedGameAssets";
import {ExorcismSound} from "./sound/ExorcismSound";
import {PossessedBackgroundElements} from "./view/PossessedBackgroundElements";
import {PossessedWinPresentation} from "./gameflow/PossessedWinPresentation";
import {PossessedNormalBetPresentation} from "./gameflow/PossessedNormalBetPresentation";
import {PossessedNormalResultPresentation} from "./gameflow/PossessedNormalResultPresentation";
import {PossessedIdleNormalPresentation} from "./gameflow/PossessedIdleNormalPresentation";
import {PossessedZeroBetIdlePresentation} from "./gameflow/PossessedZeroBetIdlePresentation";
import {PossessedGameData} from "./server/PossessedData";
import {PossessedModel} from "./server/PossessedModel";
import {PossessedReelsView} from "./reels/PossessedReelsView";
import {PossessedForegroundElements} from "./view/PossessedForegroundElements";
import {PossessedTransitionScreenView} from './view/PossessedTransitionScreenView';
import {PossessedCrucifixReelView} from './view/PossessedCrucifixReelView';
import {PossessedWinCounterView} from './view/PossessedWinCounterView';
import {Speedster} from "./debug/Speedster";
import {PossessedStatics} from './config/PossessedStatics';
import {PossessedEasterEggView} from "./view/PossessedEasterEggView";
import {SpinePreviewer} from "./debug/SpinePreviewer";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {PossessedGameMode} from "./server/PossessedGameMode";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";


export class Possessed extends SlotGame {
    public static model:PossessedModel;
    public static assetLoader:AssetLoader;
    public static soundPlayer:ExorcismSound;
    public static backgroundElements:PossessedBackgroundElements;
    public static foregroundElements:PossessedForegroundElements;
    public static easterEggView:PossessedEasterEggView;
    public static gameFlowController:GameFlowController;
    public static reelView:PossessedReelsView;
    public static transitionScreen:PossessedTransitionScreenView;
    public static crucifixReel:PossessedCrucifixReelView;
    public static winCounter:PossessedWinCounterView;

    private static isXbetEnabled:boolean = false;
    public static get xbetEnabled():boolean { return Possessed.isXbetEnabled; }
    private skinner: Skinner;

    constructor() {
        super();
        const validSkins: string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady(): Promise<any> {
        if (this.skinner.skinId != undefined) {
            const replaceMap: Map<string, string> = new Map();

            replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
            replaceMap.set("feature4", "intro_feature4.png");
            replaceMap.set("pageImage_7", "pageImage_7.png");


            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }

    private paytable: string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath: "screens/images/"
            };
            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            resolve(paytableString);
        });
    }

    public static isWinBelowStake(): boolean {
        return Possessed.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBetPrice());
    }

    public static getBetPrice(): number {
        const betLevel: string = Possessed.apiPlugin.freeBets.hasFreeBets() ? Possessed.apiPlugin.freeBets.getBet() : Possessed.apiPlugin.betLevel.getLevel();
        let price: number = Possessed.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (Possessed.model.data.wasFeatureBuy) {
            for (let index = 0; index < Possessed.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Possessed.model.initData.featureBuyTimesBetValue[index].name === Possessed.model.buyFeatureName) {
                    price *= Possessed.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private static getAccumulatedRoundWin(): number {
        return Possessed.model.data.accumulatedRoundWin;
    }

    getNoWinGameData():any {
        return {
            "reels": [
            [
                "M5",
                "M5",
                "L2",
                "L5",
                "M4"
            ],
            [
                "L3",
                "L4",
                "M1",
                "L1",
                "L3",
                "L4",
                "M3",
                "M3"
            ],
            [
                "L1",
                "L1",
                "L4",
                "L3",
                "L3",
                "L2",
                "L3",
                "L3"
            ],
            [
                "L4",
                "L5",
                "L5",
                "M5",
                "L2",
                "L1",
                "L4",
                "L5"
            ],
            [
                "L4",
                "M3",
                "L4",
                "M3",
                "M5"
            ]
        ],
            "evaluatedArea": [
            [
                "M5",
                "L2",
                "L5"
            ],
            [
                "L4",
                "M1",
                "L1",
                "L3",
                "L4",
                "M3"
            ],
            [
                "L1",
                "L4",
                "L3",
                "L3",
                "L2",
                "L3"
            ],
            [
                "L5",
                "L5",
                "M5",
                "L2",
                "L1",
                "L4"
            ],
            [
                "M3",
                "L4",
                "M3"
            ]
        ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "wasFeatureBuy": false,
            "brokeTheBank": false,
            "totalNumberOfWays": 1,
            "gameAreaSize": [
            3,
            6,
            6,
            6,
            3
        ],
            "thisSpinWinning": 0,
            "waysWonTotalRound": 0,
            "freeSpinType": 0,
            "enhancedBet": false,
            "xCrucifixReel": [
            "M1",
            "M2",
            "M3",
            "M4",
            "M5"
        ],
            "symbolSizes": [
            [
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1
            ]
        ],
            "symbolSizesXWays": [
            [
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1
            ]
        ],
            "hotZoneSize": 0,
            "wildLanded": false,
            "xinfLaded": false,
            "nextHotZoneSize": 0,
            "winMultiplier": 1
        }
    }

    public init():Promise<NolimitPlugin> {
        return super.init().then((value:NolimitPlugin) => {
            (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            // Hack to enable scissor system
            (<any>NolimitApplication.pixiApp.renderer.mask.enableScissor) = true;

            Possessed.model = new PossessedModel(SlotGame.apiPlugin, true);
            Possessed.gameFlowController = new GameFlowController(SlotGame.apiPlugin, Possessed.model);
            Possessed.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            Possessed.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => {
                const activeBetFeature = SlotKeypad.apiPlugIn.betFeatureController.getActiveBetFeature();
                if (activeBetFeature?.name == "BOOSTED_BET") {
                    if(!Possessed.model.isRestore) {
                        Possessed.soundPlayer.playSound("xbetOn");
                    }
                    Possessed.isXbetEnabled = true;
                    Possessed.backgroundElements.switchToXbet(1);
                    Possessed.reelView.reelCross.updateCross("XBET");

                } else if(Possessed.xbetEnabled && activeBetFeature?.name != "BOOSTED_BET"){
                    // xbet was toggled off
                    if(Possessed.xbetEnabled) {
                        Possessed.soundPlayer.playSound("xbetOff");
                    }

                    Possessed.isXbetEnabled = false;
                    Possessed.backgroundElements.switchFromXbet(1);
                    Possessed.reelView.reelCross.updateCross(PossessedGameMode.NORMAL);
                }
            })

            //Example
            Possessed.model.events?.on(GameModelEvent.GAME, (data:PossessedGameData) => {
                console.log(data);
            });

            const winPres = new PossessedWinPresentation();
            const idleNormal = new PossessedIdleNormalPresentation();
            const reelStart = new PossessedNormalBetPresentation();
            const normalResult = new PossessedNormalResultPresentation();
            const zeroBetIdle = new PossessedZeroBetIdlePresentation();

            Possessed.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            Possessed.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.RESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            Possessed.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            
            Possessed.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, reelStart],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            this.handleSweepInit();
            return value;
        });
    }

    public getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value:NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(PossessedGameAssets.RESOURCES_GROUPS);
            Possessed.assetLoader = new AssetLoader(Possessed.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), Possessed.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);
           

            return promises.then((values:any) => {
                this.createViewsAndComponents();

                // Split cross symbols in to individual parts
                {
                    const crossPositions:{reelID:number, reelPosition:number}[] = [
                        // left cross symbol
                        {reelID: 0, reelPosition: 2}, 
                        // middle cross symbols
                        {reelID: 1, reelPosition: 0},
                        {reelID: 1, reelPosition: 1},
                        {reelID: 1, reelPosition: 2},
                        {reelID: 1, reelPosition: 3},
                        // right cross symbol
                        {reelID: 2, reelPosition: 2}
                    ];

                    ["m1", "m2", "m3", "m4", "m5"].forEach(symbolName => {
                        crossPositions.forEach(pos => {
                            const texture = Possessed.assetLoader.getTextures("Cross syms/" + symbolName + "_cross/" + symbolName +"c_full")[0].clone();
                            const frame = texture.frame;
                            frame.x += pos.reelID * PossessedStatics.SYMBOL_WIDTH;
                            frame.y += pos.reelPosition * PossessedStatics.SYMBOL_HEIGHT + 3;
                            frame.width = PossessedStatics.SYMBOL_WIDTH;
                            frame.height = PossessedStatics.SYMBOL_HEIGHT;
                            texture.updateUvs();
                            PIXI.Texture.addToCache(texture, `Cross syms/M${symbolName[1]}_${pos.reelID+1}_${pos.reelPosition + 1}`);
                        });
                    });
                }

                //if(Exorcism.model.initData.isRestoreState) {
                //Exorcism.reelArea.restoreReels();
                //}

                return value;
            });
        });
    }

    public getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value:NolimitPlugin) => {
            return value;
        });
    }

    public start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value:NolimitPlugin) => {
            Possessed.gameFlowController.start();
            Possessed.soundPlayer.switchMusic(Possessed.model.data.mode);
            if (!Possessed.model.isRestore && !Possessed.apiPlugin.isReplay) {
                Possessed.soundPlayer.playSound("continueButton");
                //Exorcism.foregroundElements.showGameIntro();
            }
            return value;
        });
    }

    private createViewsAndComponents() {
        //Non views
        Possessed.soundPlayer = new ExorcismSound();
        
        //Static views

        Possessed.backgroundElements = new PossessedBackgroundElements();
        Possessed.backgroundElements.setMode(Possessed.model.data.nextMode);
        Possessed.reelView = new PossessedReelsView();
        Possessed.foregroundElements = new PossessedForegroundElements();
        Possessed.easterEggView = new PossessedEasterEggView();
        Possessed.transitionScreen = new PossessedTransitionScreenView();
        Possessed.crucifixReel = new PossessedCrucifixReelView();
        Possessed.winCounter = new PossessedWinCounterView();

        NolimitApplication.addLayer("Speedster", new Speedster());
        NolimitApplication.addLayerAt("Spine Previewer", new SpinePreviewer(Possessed.assetLoader));
        NolimitApplication.addLayerAt(Possessed.winCounter.name, Possessed.winCounter, 0);
        NolimitApplication.addLayerAt(Possessed.easterEggView.name, Possessed.easterEggView, 0);
        NolimitApplication.addLayerAt(Possessed.foregroundElements.name, Possessed.foregroundElements, 0);
        NolimitApplication.addLayerAt(Possessed.transitionScreen.name, Possessed.transitionScreen, 0);
        NolimitApplication.addLayerAt(Possessed.crucifixReel.name, Possessed.crucifixReel, 0);
        NolimitApplication.addLayerAt(Possessed.reelView.name, Possessed.reelView, 0);
        NolimitApplication.addLayerAt(Possessed.backgroundElements.name, Possessed.backgroundElements, 0);

        // Handle restore state
        if(Possessed.model.isRestore) {
            SlotGame.keypadPlugin.setWin(Possessed.model.initData.accumulatedRoundWin, true, Possessed.model.isWinBelowStake());
            Possessed.crucifixReel.onRestore();
            Possessed.reelView.onRestore();
            Possessed.reelView.reelCross.onRestore();
            Possessed.backgroundElements.onRestore();
        }
    }


}